'use client';

import { useEffect } from 'react';
import { useCookiebotStatisticsConsent } from '@/hooks/use-cookiebot-statistics-consent';
import { getBaseUrl } from '@/lib//utils';
import { loadDatadogRum } from '@/lib/datadog-rum';

let datadogInitialized = false;

export default function DatadogInit() {
  const hasStatisticsConsent = useCookiebotStatisticsConsent();

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      return;
    }

    async function syncDatadogConsent() {
      if (!hasStatisticsConsent && !datadogInitialized) {
        return;
      }

      const { datadogRum } = await loadDatadogRum();

      if (!datadogInitialized) {
        const sessionSampleRate = Number(process.env.NEXT_PUBLIC_DD_RUM_SESSION_SAMPLE_RATE);
        const sessionReplaySampleRate = Number(
          process.env.NEXT_PUBLIC_DD_RUM_SESSION_REPLAY_SAMPLE_RATE
        );

        datadogRum.init({
          applicationId: process.env.NEXT_PUBLIC_DD_RUM_APPLICATION_ID || '',
          clientToken: process.env.NEXT_PUBLIC_DD_RUM_CLIENT_TOKEN || '',
          site: 'us5.datadoghq.com',
          service: 'geoforge-webapp',
          env: process.env.NEXT_PUBLIC_APP_ENVIRONMENT || '',
          version: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
          sessionSampleRate: !isNaN(sessionSampleRate) ? sessionSampleRate : 100,
          sessionReplaySampleRate: !isNaN(sessionReplaySampleRate) ? sessionReplaySampleRate : 20,
          trackBfcacheViews: true,
          defaultPrivacyLevel: 'mask-user-input',
          allowedTracingUrls: [getBaseUrl()],
          trackingConsent: hasStatisticsConsent ? 'granted' : 'not-granted',
        });

        datadogInitialized = true;
        return;
      }

      datadogRum.setTrackingConsent(hasStatisticsConsent ? 'granted' : 'not-granted');

      if (!hasStatisticsConsent) {
        datadogRum.clearUser();
      }
    }

    void syncDatadogConsent();
  }, [hasStatisticsConsent]);

  return null;
}
